export enum AllCategories {
    ALL='header.menuBar.allSubcategories',
}